import {AssistantDefinition} from '../../services/ai-assistant.service';
import * as markdown from 'markdown-it';
import {UserDto} from '../../../user/data/userDto';

export class AiMessageViewModel implements IAiChatMessage {
  assistant: AssistantDefinition;
  message: string;
  finished: boolean = false;
  isStreaming: boolean = false;

  constructor(assistant: AssistantDefinition, message: string, finished: boolean = false) {
    this.assistant = assistant;
    this.message = message;
    this.finished = finished;
  }

  getHtml(): string {
    const isHtml = /<[a-z][\s\S]*>/i.test(this.message);
    if (isHtml) {
      return this.message;
    }
    const md = new markdown();
    return md.render(this.message);
  }

  getImageUrl(): string {
    return this.assistant.image;
  }

  getInitials(): string {
    return this.assistant.name.split(' ').map(n => n[0]).join('').toUpperCase();
  }

  getName(): string {
    return this.assistant.name;
  }

  getIsFinished(): boolean {
    return this.finished;
  }

  getIsStreaming(): boolean {
    return this.isStreaming;
  }

  addToken(token: string) {
    this.message += token;
  }

  startStreaming() {
    this.isStreaming = true;
    this.finished = false;
  }

  finishStreaming() {
    this.isStreaming = false;
    this.finished = true;
  }

}

export class HumanMessageViewModel implements IAiChatMessage {
  message: string;
  user: UserDto;

  constructor(user: UserDto, message: string) {
    this.message = message;
    this.user = user;
  }

  getHtml(): string {
    return this.message;
  }

  getImageUrl(): string {
    return this.user.avatarUrl;
  }

  getInitials(): string {
    return this.user.username.split(' ').map(n => n[0]).join('').toUpperCase();
  }

  getName(): string {
    return this.user.username;
  }

  getIsFinished(): boolean {
    return true;
  }

  getIsStreaming(): boolean {
    return false;
  }

  addToken(token: string) {
    this.message += token;
  }

  startStreaming() {
    // Do nothing
  }

  finishStreaming() {
    // Do nothing
  }
}


export interface IAiChatMessage {
  getHtml(): string;
  getImageUrl(): string;
  getInitials(): string;
  getName(): string;
  getIsFinished(): boolean;
  getIsStreaming(): boolean;

  addToken(token: string): void;
  startStreaming(): void;
  finishStreaming(): void;
}
